module.exports = __webpack_public_path__ + "static/media/one-of-a-kind.7e664590.jpg";